﻿(function (document) {
    document.querySelectorAll('[data-menu-toggle]').forEach(function (element, index) {
        element.addEventListener('click', function (e) {
            e.preventDefault();
            var body = document.querySelector('body');
            if (body.dataset.menu == 'open') {
                body.dataset.menu = 'closed';
            } else {
                body.dataset.menu = 'open';
            }
        });
    });
})(document);